import Enumerable from "linq";
import {
  DesignatedDoctorInformation,
  IDesignatedDoctorRepository,
} from "../../../domain/user";
import { AuthenticatedService } from "../..";
import { IDesignatedDoctorInformationBean } from "./beans";

export class DesignatedDoctorRepository extends AuthenticatedService implements IDesignatedDoctorRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getAllEntities(): Promise<DesignatedDoctorInformation[]> {
    const url = "/api/designated-doctors";
    const result = await this.get(url);
    return DesignatedDoctorRepository.toDesignatedDoctorInformations(result.data);
  }

  public static toDesignatedDoctorInformations(beans: IDesignatedDoctorInformationBean[]): DesignatedDoctorInformation[] {
    return beans
      ? Enumerable.from(beans).select(this.toDesignatedDoctorInformation).toArray()
      : [];
  }

  public static toDesignatedDoctorInformation(bean: IDesignatedDoctorInformationBean): DesignatedDoctorInformation {
    const info = new DesignatedDoctorInformation(
      bean.userCode,
      bean.typeCode,
      bean.typeName,
      bean.number,
      bean.startDate,
      bean.endDate,
    );
    Object.freeze(info);
    return info;
  }
}
